import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Mbata from "../images/mbata.jpg";
import Anas from "../images/anas.jpg";
import "./testimonialSlider.css";
import ShashankPrakash from "../images/shashankPrakash.jpg";
import TestimonialCard from "./testimonialCard";
const options = {
  items: 4,
  loop: true,
  margin: 10,
  responsiveClass: true
};
let responsive = {
  0: {
    items: 1,
    nav: true,
    loop: true
  }
};

const TestinomialData = [
  {
    name: "Shashank Prakash",
    rating: "4.5",
    position: "CTO, Bybrisk",
    desc:
      "Driven Perfectionalist! Cellar tech helped me built our product from scratch to deployment. I would love to join forces with them any day.",
    image: ShashankPrakash
  },
  {
    name: "Azikari Mbata",
    rating: "4",
    position: "CEO, Safari Smart",
    desc:
      "The team is so smart, communicative, and on time delivery. The app was performing well and of highest quality! I will keep working with them",
    image: Mbata
  },
  {
    name: "Md Anas",
    rating: "4",
    position: "CEO, Aturservices",
    desc:
      "Cellar Tech handled the app from planning to adding feature and solving bugs. A great team to work with.",
    image: Anas
  }
];

function TestimonialSlider() {
  return (
    <section className="testimonial-carousel">
      <OwlCarousel
        options={options}
        className="owl-theme"
        loop
        margin={10}
        nav
        responsiveClass
        responsive={responsive}
        // autoplay
        autoplayTimeout={3000}
        autoplayHoverPause
      >
        <div class="item">
          <TestimonialCard
            name={TestinomialData[0].name}
            desc={TestinomialData[0].desc}
            position={TestinomialData[0].position}
            image={TestinomialData[0].image}
          />
        </div>
        <div class="item">
          <TestimonialCard
            name={TestinomialData[1].name}
            desc={TestinomialData[1].desc}
            position={TestinomialData[1].position}
            image={TestinomialData[1].image}
          />{" "}
        </div>
        <div class="item">
          <TestimonialCard
            name={TestinomialData[2].name}
            desc={TestinomialData[2].desc}
            position={TestinomialData[2].position}
            image={TestinomialData[2].image}
          />{" "}
        </div>
      </OwlCarousel>
    </section>
  );
}

export default TestimonialSlider;
